import { ACTIVITY_TYPES } from './types';

const Colors = {
  [ACTIVITY_TYPES.video]: '#117DC5',
  [ACTIVITY_TYPES.game]: '#F169F4',
  [ACTIVITY_TYPES.song]: '#62247E',
  [ACTIVITY_TYPES.worksheet]: '#37A434',
  [ACTIVITY_TYPES.pictureDictionary]: '#EA9A00',
  [ACTIVITY_TYPES.craft]: '#F0473E',
  [ACTIVITY_TYPES.interactiveVideo]: '#8DBA21',
  [ACTIVITY_TYPES.realTime]: '#853F71',
  [ACTIVITY_TYPES.external]: '#CCCCCC',
  [ACTIVITY_TYPES.comic]: '#3ABEEF',
  [ACTIVITY_TYPES.storyWithQuestions]: '#FF6699',
  [ACTIVITY_TYPES.songQuestions]: '#5243aa',
  [ACTIVITY_TYPES.reinforcement]: '#E8590C',
};

export default Colors;
